import GenericModel from './generic-model';

export class Telephone extends GenericModel {
  type?: string;
  number: string;
}
